import { Component, ElementRef, ViewChild } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import {
  FilterableSettings,
  DataBindingDirective,
  GridDataResult,
  PageChangeEvent,
  DataStateChangeEvent,
  GridComponent,
} from '@progress/kendo-angular-grid';
import Swal from 'sweetalert2';
import { DecimalPipe, formatDate } from '@angular/common';
import { SVGIcon, filePdfIcon, fileExcelIcon } from '@progress/kendo-svg-icons';
import { process } from '@progress/kendo-data-query';
import { TooltipDirective } from '@progress/kendo-angular-tooltip';
import {
  SelectableSettings,
  SelectableMode,
} from '@progress/kendo-angular-grid';
import { Subject, of } from 'rxjs';
import {
  debounceTime,
  distinctUntilChanged,
  filter,
  switchMap,
} from 'rxjs/operators';
import {
  AbstractControl,
  FormArray,
  FormControl,
  FormGroup,
  UntypedFormBuilder,
  UntypedFormGroup,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { Store, compose, select } from '@ngrx/store';
import { LoaderService } from '../../../core/services/loader.service';
import { Validations } from '../../../shared/constants/validations';
import {
  orderBy,
  SortDescriptor,
  filterBy,
  CompositeFilterDescriptor,
  FilterDescriptor,
} from '@progress/kendo-data-query';

import {
  DragOverEvent,
  NavigateEvent,
  SortableComponent,
} from '@progress/kendo-angular-sortable';
import { SharedService } from '../../../shared/shared.service';
import { ResidentialunitService } from '../../../core/services/residentialunit.service';
import {
  createResidentialUnit,
  getExportResidentialHistory,
  getOccupationHistoryExpotyExcellist,
  getResidentialHistorylist,
  getResidentialUnitByIdlist,
  reseExportResidentialHistorytState,
  resetOccupaintHistoryState,
  resetResidentialUnitState,
  updateResidentialUnit,
} from '../../../store/residential-unit/residentialUnit.action';

import {
  getExportResidentialHistoryResponse,
  getOccupationHistoryExpotyExcelResponse,
  getOccupationHistoryResponse,
  getResidentialHistoryResponse,
  getResidentialUnitByIdResponse,
} from '../../../store/residential-unit/residentialUnit-selector';
import { take } from 'rxjs';
import { table_pageSize } from '../../../shared/constants/templatesNames';
import {
  residenatilTypes,
  SweetAlertIcon,
  UtilityType,
} from '../../../shared/constants/enum';
import { PdfexportService } from '../../../core/services/pdfexport.service';
import { State } from '@progress/kendo-data-query';
import {
  BsDatepickerConfig,
  BsDatepickerDirective,
} from 'ngx-bootstrap/datepicker';
import _ from 'lodash';
import { Helper } from '../../../core/helpers/helper';
@Component({
  selector: 'app-rp-create-residential-unit',
  templateUrl: './rp-create-residential-unit.component.html',
  styleUrl: './rp-create-residential-unit.component.scss',
  standalone: false,
})
export class RpCreateResidentialUnitComponent {
  @ViewChild('sortable') public sortable!: SortableComponent;
  prifileValidations = Validations;
  residentialUnitForm!: UntypedFormGroup;
  @ViewChild('pdfGrid') public hiddenGrid: GridComponent | undefined;
  @ViewChild('umdpdfGrid') public umdGrid: GridComponent | undefined;
  umdForm!: UntypedFormGroup;
  currentPage: number = 1;
  breadCrumbItems: Array<{}> | undefined;
  lengthOfgas = 'Gas';
  lengthOFwater = 'Water';
  lengthOfelectricity = 'Electricity';
  lengthOfelTriSource = 'TriSource';
  public selectableSettings!: SelectableSettings;
  currentUserData: any;
  projectId: any;
  billingType: any;
  configData: any;
  datePickerConfig: Partial<BsDatepickerConfig> | undefined;
  maxdatePickerConfig: Partial<BsDatepickerConfig> | undefined;
  today: Date;
  residenatilTypes = residenatilTypes;
  minDate: any;
  readingsMindate: any;
  public utilitySearch$ = new Subject<string>();
  public isLoading = false;
  ocupanyList: any[] = [];
  ownerList: any[] = [];
  umdUtilityTypeList: any[] = [];
  isownerFilterList: any[] = [];
  isGasOpen: boolean = false;
  isWaterOpen: boolean = false;
  isEleOpen: boolean = false;
  isTriOpen: boolean = false;
  selectedOccupant: any;
  selectedOwner: any;
  ocupantForm!: UntypedFormGroup;
  isOcupantEnable: boolean = false;
  fromDate: any;
  fromDat_vacantDate: any;
  fromDate_moveDate: any;
  searchedOccupant: string = '';
  searchedUmd: string = '';
  submitted: boolean = false;
  occupantSubmitted: boolean = false;
  current_occpanyList: any[] = [];
  umdqueryString: string = '';
  umdorderByQuery: string = '';
  meter_HistoryByQuery: string = '';
  queryString: string = '';
  orderByQuery: string = '';
  public value: Date = new Date(2000, 2, 10);

  modalRef!: BsModalRef;
  modelRef_1!: BsModalRef;
  removeModalRef!: BsModalRef;
  config: any = {
    backdrop: true,
    ignoreBackdropClick: true,
  };

  isCreate = 'create';
  public occupationState: State = {
    skip: 0,
    take: 10,
    filter: {
      logic: 'and',
      filters: [],
    },
  };
  public umdState: State = {
    skip: 0,
    take: 10,
    filter: {
      logic: 'and',
      filters: [],
    },
  };
  //occupation_History
  public pageSize = 10;
  public umdhistorypageSize = 10;
  public skip = 0;
  public umdskip = 0;
  UmdcurrentPage: number = 1;
  occupaintvacantdate: any;
  totalUserCount: number = 0;
  umdhistorytotalUserCount: number = 0;
  public residentialunitgridData: GridDataResult = { data: [], total: 0 };
  public residentialunitUmdHistorygridData: GridDataResult = {
    data: [],
    total: 0,
  };

  occupationHistoryList: any[] = [];
  umdexportdata: any[] = [];
  exportdata: any[] = [];
  selectedRowdata: any = [];
  deselectedRowdata: any = [];
  umdselectedRowdata: any = [];
  umddeselectedRowdata: any = [];
  macAddressEleArray: any[] = [];

  macAddressTriSourceArray: any[] = [];
  macAddressEVArray: any[] = [];

  selectedvlaue: any[] = [];
  selectedUtilityType: any;
  selectedUtilitymeter: any[] = [];
  uitilityMetersList: any[] = [];
  electricityList: any[] = [];
  filteredUtilityMeters: any[] = [];
  WaterList: any[] = [];
  triSourceList: any[] = [];
  gasList: any[] = [];
  utilityTypeList: any[] = [];
  projectByUserList: any[] = [];
  macAddressWaterArray: any[] = [];
  macAddressGasArray: any[] = [];
  public buttonCount = 5;
  public info = true;
  public type: 'numeric' | 'input' = 'numeric';
  public pageSizes = table_pageSize.pageSizes;
  public previousNext = true;
  public sort: SortDescriptor[] = [];
  public umdsort: SortDescriptor[] = [];

  public filter: CompositeFilterDescriptor = { logic: 'and', filters: [] };

  public umdfilter: CompositeFilterDescriptor = { logic: 'and', filters: [] };

  selectValue!: string[];
  isAllOpen: boolean = true;
  @ViewChild('datepicker', { static: false })
  datePicker!: BsDatepickerDirective;
  @ViewChild('datepicker2', { static: false })
  datePicker2!: BsDatepickerDirective;
  @ViewChild('datepickergas1', { static: false })
  datepickergas1!: BsDatepickerDirective;
  @ViewChild('datepickergas2', { static: false })
  datepickergas2!: BsDatepickerDirective;
  @ViewChild('datepickerEle1', { static: false })
  datepickerEle1!: BsDatepickerDirective;
  @ViewChild('datepickerEle2', { static: false })
  datepickerEle2!: BsDatepickerDirective;
  public filePdfIcon: SVGIcon = filePdfIcon;
  public fileExcelIcon: SVGIcon = fileExcelIcon;
  residentialUniUmdHistoryList: any[] = [];
  private exportSubscription: Subscription = new Subscription();
  private exportumdSubscription: Subscription = new Subscription();
  @ViewChild(DataBindingDirective) dataBinding!: DataBindingDirective;
  billGenerationDate: any;
  public gridView!: unknown[];
  updated_residenatilUnit = Object.assign({});
  residenatilUnitByidData: any = {};
  regex = /^[a-zA-Z0-9,#-]+(?: [a-zA-Z0-9,#-]+)*$/;
  //regex = /^[a-zA-Z0-9,#-]*$/;
  /// regex_Alphanumeric = /^[a-zA-Z0-9]*$/; //Only Alpha numeric are allowed
  regex_Alphanumeric = '^[a-zA-Z0-9]+( [a-zA-Z0-9]+)*$';
  //regexp = /^[0-9]*(\.[0-9]{0,2})?$/; // "Only Number with 2 decimals allowed
  // initialReadingExp = '^\\d{1,5}(\\.\\d{1,2})?$';
  initialReadingExp = '^\\d+(\\.\\d{1,2})?$';
  public checkboxOnly = true;
  public mode: SelectableMode = 'multiple';
  public drag = false;
  billingDate: any;
  ConsumptionDate: any;
  Project_startDate: any;
  @ViewChild('datePickerInput') datePickerInput!: ElementRef;
  constructor(
    private modalService: BsModalService,
    private formBuilder: UntypedFormBuilder,
    private loaderService: LoaderService,
    private sharedService: SharedService,
    private router: Router,
    private store: Store,
    private PdfexportService: PdfexportService,
    private residentialunitService: ResidentialunitService,
  ) {
    this.selectableSettings = {
      checkboxOnly: this.checkboxOnly,
      mode: this.mode,
      drag: this.drag,
    };

    if (
      history.state.residentialData != undefined &&
      history.state.residentialData !== null
    ) {
      this.updated_residenatilUnit = history.state.residentialData;
    }

    const currentUserString = localStorage.getItem('currentUser');
    this.currentUserData = JSON.parse(currentUserString ?? '');
    this.projectByUserList = this.currentUserData?.projectUtilities || [];
    this.umdUtilityTypeList = this.projectByUserList.filter(
  (utility: any) =>
    (utility?.name ?? utility?.Name ?? '').toString().trim().toLowerCase() !== 'ev'
);
    // console.log(this.currentUserData);
    this.billGenerationDate = this.currentUserData?.billGenerationDate;
    if (this.currentUserData.project !== null) {
      this.projectId = this.currentUserData.project.id;
      // this.billingDate = this.currentUserData.project.billingDate;
      this.ConsumptionDate = this.currentUserData.project.ConsumptionDate;
      this.billingType = this.currentUserData.project.billingType;
      this.Project_startDate = this.currentUserData.project.startDate;
    }
    this.today = new Date();
    this.getAllConfigData();
    // this.minDate = new Date('2024-10-01T18:30:00.000Z')
    //let dt = this.billGenerationDate != null ? new Date(this.billGenerationDate) : null;

    if (!this.updated_residenatilUnit?.id) {
      console.log(this.Project_startDate);
      const Project_startDate =
        this.Project_startDate != null
          ? new Date(this.Project_startDate)
          : null;
      this.minDate = Project_startDate ?? this.today; // Using the nullish coalescing operator for better readability
      console.log(Project_startDate);
    }
    console.log(this.minDate);

    this.maxdatePickerConfig = {
      containerClass: 'theme-dark-blue',
      rangeSeparator: ' to ',
      dateInputFormat: 'DD/MM/YYYY',
      //minDate: new Date(2015, 0, 1), // January is month index 0
      minDate: this.minDate,
      maxDate: new Date(),
      showWeekNumbers: false,

      // other configurations as needed
    };
    /*  this.datePickerConfig = Object.assign({}, {
       dateInputFormat: 'DD/MM/YYYY', // Set to dd/MM/yyyy format
       showWeekNumbers: false
     }); */
    this.datePickerConfig = Object.assign(
      {},
      {
        dateInputFormat: 'DD/MM/YYYY', // Customize as needed
        showWeekNumbers: false,
        isAnimated: true,
        containerClass: 'theme-dark-blue',
      },
    );

    this.breadCrumbItems = [
      { label: 'Residential unit', url: 'residentialUnit', active: true },
      {
        label: this.updated_residenatilUnit?.id
          ? 'Update residential unit'
          : 'Create residential',
      },
    ];
    this.residentialUnitForm = this.formBuilder.group({
      flat_house: [
        '',
        [
          Validators.required,
          Validators.pattern(this.regex),
          Validators.maxLength(10),
        ],
      ],
      floor: [
        '',
        [
          Validators.required,
          Validators.pattern(this.regex),
          Validators.maxLength(5),
        ],
      ],
      tower: [
        '',
        [
          Validators.required,
          Validators.pattern(this.regex),
          Validators.maxLength(5),
        ],
      ],
      block: [
        '',
        [
          Validators.required,
          Validators.pattern(this.regex),
          Validators.maxLength(15),
        ],
      ],
      noOfGasMetersRequired: [0],
      noOfWaterMetersRequired: [0],
      noOfElectricityMetersRequired: [0],
      noOfTriSourceMetersRequired: [0],

      Occupant_Name: [],
      currentOccupiedPerson: [''],
      owner_name: [],
      residenatilTypes: ['', [Validators.required]],
      Square_feet: [
        '',
        [
          Validators.required,
          Validators.max(10000),
          Validators.maxLength(5),
          Validators.pattern(/^(0|[1-9]\d{0,4})(\.\d{1,2})?$/),
        ],
      ],
      date_registered: [],
      gas_array: this.formBuilder.array([]),
      water_array: this.formBuilder.array([]),
      electricity_array: this.formBuilder.array([]),
      triSource_array: this.formBuilder.array([]),
    });
    this.ocupantForm = this.formBuilder.group({
      ocupantName: ['', [Validators.required]],
      move_In_Date: [null, [Validators.required]],
      // Vacant_Date: [''],
    });
    this.umdForm = this.formBuilder.group({
      utitlityType: [null, Validators.required],
      utitlityMeters: [null, Validators.required],
    });
  }
  onDateRangeSelected(event: any): void {
    console.log('Selected date:', event);
    this.selectedDate = event;

    // Handle the selected date here
  }
  filterOccupant() {
    //console.log('occupaint input:', occupaint);
    console.log('Initial ownerList:', this.ownerList);

    if (!this.ownerList || this.ownerList.length === 0) {
      console.warn('ownerList is empty or undefined');
      return;
    }

    const currentOccupantId = this.residenatilUnitByidData?.occupantId;
    const emailById = new Map(
      (this.ownerList || []).map((item: any) => [item.id, item.email ?? '']),
    );
    const baseList = (this.ocupanyList || []).map((item: any) => ({
      ...item,
      email: item.email ?? emailById.get(item.id) ?? '',
    }));

    if (currentOccupantId) {
      const currentOccupant = this.ownerList.find(
        (item: any) => item.id === currentOccupantId,
      );
      if (
        currentOccupant &&
        !baseList.some((item: any) => item.id === currentOccupant.id)
      ) {
        baseList.unshift(currentOccupant);
      }
    }

    if (this.residentialUnitForm.controls['Occupant_Name'].value) {
      this.isownerFilterList = baseList.filter((person: any) => {
        if (currentOccupantId && person.id === currentOccupantId) return true;
        const fullName = (person.name || '').toLowerCase();
        console.log('Comparing fullName:', fullName);
        console.log(
          'Against occupant:',
          this.residentialUnitForm.controls['Occupant_Name'].value,
        );
        return !fullName.includes(
          this.residentialUnitForm.controls[
            'Occupant_Name'
          ].value?.toLowerCase(),
        );
      });
    } else {
      this.isownerFilterList = baseList;
    }

    //console.log('Filtered ownerList:', this.ownerList);
  }

  closeModal() {
    console.log('close modal');
    this.modelRef_1.hide();
    this.umdForm.reset();
    this.selectedUtilityType = null;
    this.uitilityMetersList = [];
    // this.umdForm.reset();
  }
  public isRippleEVUnitRateEnabled(): boolean {
    return !!(
      this.currentUserData?.project?.isRippleUnitRate ??
      this.currentUserData?.project?.IsRippleUnitRate ??
      false
    );
  }

  public selectedUmdUtilityIsEV(): boolean {
    // Prefer the value set by utilityChange (selectedUtilityType)
    const utilObj = this.selectedUtilityType ?? this.umdForm.get('utitlityType')?.value;
    if (!utilObj) return false;
    const name = (utilObj?.name ?? utilObj?.Name ?? (typeof utilObj === 'string' ? utilObj : ''));
    return name.toString().trim().toLowerCase() === 'ev';
  }
  
  ngOnDestroy() {
    this.exportSubscription.unsubscribe();
    this.exportumdSubscription.unsubscribe();
  }
  loadUmdHistrory() {
    const state: any = {
      take: this.umdhistorypageSize,
      sort: this.umdsort,
      filter: this.umdfilter,
    };

    const processedData = process(this.residentialUniUmdHistoryList, state);
    this.residentialunitUmdHistorygridData = {
      data: this.residentialUniUmdHistoryList,
      total: this.umdhistorytotalUserCount,
    };

    this.residentialunitUmdHistorygridData.data =
      this.residentialunitUmdHistorygridData?.data.map((item) => {
        // console.log(new Date(project.currentDate));
        return {
          ...item,
          updatedOn:
            item?.modifiedOn != null
              ? this.sharedService.dateFormateChnage(item?.modifiedOn)
              : '-',
          meterInstallation_Date:
            item?.meterInstallationDate != null
              ? this.sharedService.dateFormateChnage(
                  item?.meterInstallationDate,
                )
              : '-',
          initialReading_Date:
            item?.initialReadingDate != null
              ? this.sharedService.dateFormateChnage(item?.initialReadingDate)
              : '-',
        };
      });

    this.loaderService.setLoading(false);
  }

  loadGridTable() {
    const state: any = {
      take: this.pageSize,
      sort: this.sort,
      filter: this.filter,
    };
    const processedData = process(this.occupationHistoryList, state);
    this.residentialunitgridData = {
      data: this.occupationHistoryList,
      total: this.totalUserCount,
    };

    this.residentialunitgridData.data = this.residentialunitgridData?.data.map(
      (item) => {
        // console.log(new Date(project.currentDate));
        return {
          ...item,
          moveIn_Date:
            item?.moveInDate != null
              ? this.sharedService.dateFormateChnagewithoutTime(
                  item?.moveInDate,
                )
              : '-',
          vacate_Date:
            item?.vacateDate != null
              ? this.sharedService.dateFormateChnagewithoutTime(
                  item?.vacateDate,
                )
              : '-',
        };
      },
    );
    this.loaderService.setLoading(false);
  }

  protected residentialStateChange(state: DataStateChangeEvent): void {
    this.sort = state.sort || [];
    this.filter = state.filter || { logic: 'and', filters: [] };
    this.loadGridTable();
  }
  protected umdStateChange(state: DataStateChangeEvent): void {
    this.umdsort = state.sort || [];
    this.umdfilter = state.filter || { logic: 'and', filters: [] };
    this.loadUmdHistrory();
  }
  protected OccupationHistory({ skip, take }: PageChangeEvent): void {
    console.log('>>>', skip, take);
    this.selectedRowdata = [];
    this.skip = skip;
    this.pageSize = take;
    this.currentPage = Math.floor(skip / take) + 1;
    console.log('currentpage', Math.floor(skip / take) + 1);
    this.getOccupationHistorylist();
    /* this.store.dispatch(
      getOccupationHistorylist({
        id: this.updated_residenatilUnit.id,
        pageIndex: 1,
        pageSize: this.pageSize,
        searchTerm: this.searchedOccupant,
        filter: this.queryString,
        orderBy: this.orderByQuery,
      })
    ); */

    this.loadGridTable();
  }
  protected umdPageChange({ skip, take }: PageChangeEvent): void {
    console.log('>>>', skip, take);
    this.umdselectedRowdata = [];
    this.umdskip = skip;
    this.umdhistorypageSize = take;
    this.UmdcurrentPage = Math.floor(skip / take) + 1;
    console.log('currentpage', Math.floor(skip / take) + 1);
    this.getResidentialHistorylist();
    /* this.store.dispatch(
      getResidentialHistorylist({
        pageIndex: this.UmdcurrentPage,
        pageSize: this.umdhistorypageSize,
        searchTerm: this.searchedUmd,
        id: this.projectId,
        filter: this.umdqueryString,
        orderBy: this.umdorderByQuery,
        residentialunitid: this.updated_residenatilUnit.id,
      })
    ); */

    this.loadGridTable();
  }

  add_gas_Row(meter: any, index: number): void {
    let row = this.formBuilder.group({
      /*  Umd_sR_no: [meter.deviceSrno, Validators.required],disale:true,
       type: ['Gas', Validators.required], */
      Umd_sR_no: [
        { value: meter.deviceSrno, disabled: true },
        Validators.required,
      ],
      type: [{ value: 'Gas', disabled: true }, Validators.required],
      installed_Location: [
        '',
        [
          Validators.required,
          Validators.pattern(this.regex_Alphanumeric),
          Validators.maxLength(25),
        ],
      ],
      meterInstallation_Date: [, [Validators.required]],
      initialReading: [
        '',
        [
          Validators.required,
          Validators.pattern(this.initialReadingExp),
          this.maxLimitValidator(99999),
        ],
      ],
      meter_InitialReadingDate: ['', [Validators.required]],
      umdNo: [meter.id],
    });
    this.macAddressGasArray.push(meter.macAddress);
    this.gas_array.push(row);

    let dt = this.residentialUnitForm.controls['gas_array'] as FormArray;
    // let Umd_sR_no = dt.at(index).get('Umd_sR_no')?.disable();
    // let type = dt.at(index).get('type')?.disable();
    this.lengthOfgas = `Gas ( ${this.gas_array.length})`;
    if (this.gas_array.length > 0) {
      this.isGasOpen = true;
    }
    console.log(this.gas_array.value);
  }
  get gas_array(): FormArray {
    return this.residentialUnitForm.get('gas_array') as FormArray;
  }

  umdonSelect(event: any) {
    console.log(event.selectedRows);
    var selectedval = event.selectedRows;
    var deselectedVal = event.deselectedRows;
    if (selectedval.length > 0) {
      selectedval.forEach((element: any) => {
        this.umdselectedRowdata.push(element.dataItem);
        console.log(' selected Values : ', this.umdselectedRowdata);
      });
    }
    if (deselectedVal.length > 0) {
      deselectedVal.forEach((element: any) => {
        this.umddeselectedRowdata.push(element.dataItem);
        console.log('deselectedRowdata Values : ', this.umddeselectedRowdata);
      });

      if (this.umddeselectedRowdata.length > 0) {
        const idsToRemove = new Set(
          this.umddeselectedRowdata.map((item: { id: any }) => item.id),
        );

        const filteredArray = this.umdselectedRowdata.filter(
          (item: { id: unknown }) => !idsToRemove.has(item.id),
        );
        console.log('', filteredArray);
        this.umdselectedRowdata = filteredArray;
      }
    }
  }
  onSelect(event: any) {
    console.log(event.selectedRows);
    var selectedval = event.selectedRows;
    var deselectedVal = event.deselectedRows;
    if (selectedval.length > 0) {
      selectedval.forEach((element: any) => {
        this.selectedRowdata.push(element.dataItem);
        console.log(' selected Values : ', this.selectedRowdata);
      });
    }
    if (deselectedVal.length > 0) {
      deselectedVal.forEach((element: any) => {
        this.deselectedRowdata.push(element.dataItem);
        console.log('deselectedRowdata Values : ', this.deselectedRowdata);
      });

      if (this.deselectedRowdata.length > 0) {
        const idsToRemove = new Set(
          this.deselectedRowdata.map((item: { id: any }) => item.id),
        );

        const filteredArray = this.selectedRowdata.filter(
          (item: { id: unknown }) => !idsToRemove.has(item.id),
        );
        console.log('', filteredArray);
        this.selectedRowdata = filteredArray;
      }
    }
  }
  private removeGasRow(index: number): void {
    this.gas_array.removeAt(index);
    this.macAddressGasArray.splice(index, 1);

    this.lengthOfgas =
      this.gas_array.length > 0 ? `Gas ( ${this.gas_array.length} )` : 'Gas';

    if (this.gas_array.length === 0) {
      this.isGasOpen = false;
    }
  }

  removie_gas(index: number) {
    console.log(this.gas_array.at(index).value);
    const row = this.gas_array.at(index);
    const gasData = row.getRawValue();

    console.log('Removed Gas Row Data:', gasData);

    console.log('get by id dataa ', this.residenatilUnitByidData?.gas);

    const existingGasList = this.residenatilUnitByidData?.gas || [];

    // ✅ Check if this row exists in backend data
    const isExistingLinkedMeter = existingGasList.some(
      (item: any) => item.deviceSrno === gasData.Umd_sR_no,
    );

    // 👉 If NOT existing → remove directly (NO popup)
    if (!isExistingLinkedMeter) {
      this.removeGasRow(index);
      return;
    }
    let type = this.billingType == 'Postpaid' ? 'Bill' : 'Statements';

    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-primary',
        cancelButton: 'btn btn-outline-primary ms-2',
      },
      buttonsStyling: false,
    });

    swalWithBootstrapButtons
      .fire({
        title: 'Are you sure?',
        text: `A ${type} will be generated upon unlinking this meter to this Residential Unit, Are you sure want to unlink this Meter ? `,
        icon: 'warning',
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, cancel!',
        showCancelButton: true,
      })
      .then((result) => {
        if (result.value) {
          this.gas_array.removeAt(index);
          this.macAddressGasArray.splice(index, 1);
          this.lengthOfgas =
            this.gas_array.length > 0
              ? `Gas ( ${this.gas_array.length})`
              : 'Gas';
          if (this.gas_array.length == 0) {
            this.isGasOpen = false;
          }
          /*  swalWithBootstrapButtons.fire(
             'Deleted!',
             'Your file has been deleted.',
             'success'
           ); */
        } else if (
          /* Read more about handling dismissals below */
          result.dismiss === Swal.DismissReason.cancel
        ) {
        }
      });
  }
  private removewaterRow(index: number): void {
    this.water_array.removeAt(index);
    this.macAddressWaterArray.splice(index, 1);
    this.lengthOFwater =
      this.water_array.length > 0
        ? `Water ( ${this.water_array.length})`
        : 'Water';
    if (this.water_array.length == 0) {
      this.isWaterOpen = false;
    }
  }
  removie_water(index: number) {
    console.log(this.water_array.at(index).value);
    const row = this.water_array.at(index);
    const waterData = row.getRawValue();

    console.log('Removed Water Row Data:', waterData);

    console.log('get by id dataa ', this.residenatilUnitByidData?.water);

    const existingGasList = this.residenatilUnitByidData?.water || [];

    // ✅ Check if this row exists in backend data
    const isExistingLinkedMeter = existingGasList.some(
      (item: any) => item.deviceSrno === waterData.Umd_sR_no,
    );

    // 👉 If NOT existing → remove directly (NO popup)
    if (!isExistingLinkedMeter) {
      this.removewaterRow(index);
      return;
    }

    let type = this.billingType == 'Postpaid' ? 'Bill' : 'Statements';
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-primary',
        cancelButton: 'btn btn-outline-primary ms-2',
      },
      buttonsStyling: false,
    });
    swalWithBootstrapButtons
      .fire({
        title: 'Are you sure?',
        text: `A ${type} will be generated upon unlinking this meter to this Residential Unit, Are you sure want to unlink this Meter ? `,
        icon: 'warning',
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, cancel!',
        showCancelButton: true,
      })
      .then((result) => {
        if (result.value) {
          this.water_array.removeAt(index);
          this.macAddressWaterArray.splice(index, 1);
          this.lengthOFwater =
            this.water_array.length > 0
              ? `Water ( ${this.water_array.length})`
              : 'Water';
          if (this.water_array.length == 0) {
            this.isWaterOpen = false;
          }
          /*  swalWithBootstrapButtons.fire(
             'Deleted!',
             'Your file has been deleted.',
             'success'
           ); */
        } else if (
          /* Read more about handling dismissals below */
          result.dismiss === Swal.DismissReason.cancel
        ) {
        }
      });
  }
  private removeEleRow(index: number): void {
    this.electricity_array.removeAt(index);
    this.macAddressEleArray.splice(index, 1);
    this.lengthOfelectricity =
      this.electricity_array.length > 0
        ? `Electricity ( ${this.electricity_array.length})`
        : 'Electricity';
    if (this.electricity_array.length == 0) {
      this.isEleOpen = false;
    }
  }
  removie_Ele(index: number) {
    console.log(this.electricity_array.at(index).value);
    const row = this.electricity_array.at(index);
    const eleData = row.getRawValue();

    console.log('Removed Electricity Row Data:', eleData);

    console.log('get by id dataa ', this.residenatilUnitByidData?.electricity);

    const existingGasList = this.residenatilUnitByidData?.electricity || [];

    // ✅ Check if this row exists in backend data
    const isExistingLinkedMeter = existingGasList.some(
      (item: any) => item.deviceSrno === eleData.Umd_sR_no,
    );

    // 👉 If NOT existing → remove directly (NO popup)
    if (!isExistingLinkedMeter) {
      this.removeEleRow(index);
      return;
    }

    let type = this.billingType == 'Postpaid' ? 'Bill' : 'Statements';
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-primary',
        cancelButton: 'btn btn-outline-primary ms-2',
      },
      buttonsStyling: false,
    });

    swalWithBootstrapButtons
      .fire({
        title: 'Are you sure?',
        text: `A ${type} will be generated upon unlinking this meter to this Residential Unit, Are you sure want to unlink this Meter ? `,
        icon: 'warning',
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, cancel!',
        showCancelButton: true,
      })
      .then((result) => {
        if (result.value) {
          this.electricity_array.removeAt(index);
          this.macAddressEleArray.splice(index, 1);
          this.lengthOfelectricity =
            this.electricity_array.length > 0
              ? `Electricity ( ${this.electricity_array.length})`
              : 'Electricity';
          if (this.electricity_array.length == 0) {
            this.isEleOpen = false;
          }
          /*  swalWithBootstrapButtons.fire(
             'Deleted!',
             'Your file has been deleted.',
             'success'
           ); */
        } else if (
          /* Read more about handling dismissals below */
          result.dismiss === Swal.DismissReason.cancel
        ) {
        }
      });
  }
  private removeTriSourceRow(index: number): void {
    this.triSource_array.removeAt(index);
    console.log('triSource_array before remove:', this.triSource_array);
    this.macAddressTriSourceArray.splice(index, 1);
    this.lengthOfelectricity =
      this.triSource_array.length > 0
        ? `TriSource ( ${this.triSource_array.length})`
        : 'TriSource';
    if (this.triSource_array.length == 0) {
      this.isTriOpen = false;
    }
  }
  removie_Trisource(index: number) {
    console.log(this.triSource_array.at(index).value);
    const row = this.triSource_array.at(index);
    const triSourceData = row.getRawValue();

    console.log('Removed TriSource Row Data:', triSourceData);

    console.log('get by id dataa ', this.residenatilUnitByidData?.triSource);

    const existingtriList = this.residenatilUnitByidData?.triSource || [];

    // ✅ Check if this row exists in backend data
    const isExistingLinkedMeter =
      existingtriList.length > 0 &&
      existingtriList.some(
        (item: any) => item.deviceSrno === triSourceData.Umd_sR_no,
      );
    console.log('isExistingLinkedMeter', isExistingLinkedMeter);
    // 👉 If NOT existing → remove directly (NO popup)
    if (!isExistingLinkedMeter) {
      this.removeTriSourceRow(index);
      return;
    }

    let type = this.billingType == 'Postpaid' ? 'Bill' : 'Statements';
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-primary',
        cancelButton: 'btn btn-outline-primary ms-2',
      },
      buttonsStyling: false,
    });

    swalWithBootstrapButtons
      .fire({
        title: 'Are you sure?',
        text: `A ${type} will be generated upon unlinking this meter to this Residential Unit, Are you sure want to unlink this Meter ? `,
        icon: 'warning',
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, cancel!',
        showCancelButton: true,
      })
      .then((result) => {
        if (result.value) {
          this.triSource_array.removeAt(index);
          this.macAddressTriSourceArray.splice(index, 1);
          this.lengthOfelectricity =
            this.triSource_array.length > 0
              ? `TriSource ( ${this.triSource_array.length})`
              : 'TriSource';
          if (this.triSource_array.length == 0) {
            this.isTriOpen = false;
          }
          /*  swalWithBootstrapButtons.fire(
             'Deleted!',
             'Your file has been deleted.',
             'success'
           ); */
        } else if (
          /* Read more about handling dismissals below */
          result.dismiss === Swal.DismissReason.cancel
        ) {
        }
      });
  }

  get occpantControls() {
    return this.ocupantForm.controls;
  }
  get umdFormControls() {
    return this.umdForm.controls;
  }

  add_electricity_Row(meter: any, index: number): void {
    console.log(meter);
    let row = this.formBuilder.group({
      Umd_sR_no: [
        { value: meter.deviceSrno, disabled: true },
        Validators.required,
      ],
      type: [{ value: 'Electricity', disabled: true }, Validators.required],
      /*  Umd_sR_no: [meter.deviceSrno, Validators.required],
       type: ['Electricity', Validators.required], */
      installed_Location: [
        '',
        [
          Validators.required,
          Validators.pattern(this.regex_Alphanumeric),
          Validators.maxLength(25),
        ],
      ],
      meterInstallation_Date: [, [Validators.required]],
      initialReading: [
        '',
        [
          Validators.pattern(this.initialReadingExp),
          this.maxLimitValidator(99999),
        ],
      ],
      meter_InitialReadingDate: ['', [Validators.required]],
      Meter_Initial_Reading_EB_KWH: [
        '',
        [
          Validators.required,
          Validators.pattern(this.initialReadingExp),
          this.maxLimitValidator(99999),
        ],
      ],
      Meter_Initial_Reading_DG_KWH: [
        '',
        [
          Validators.required,
          Validators.pattern(this.initialReadingExp),
          this.maxLimitValidator(99999),
        ],
      ],
      umdNo: [meter.id],
    });
    this.macAddressEleArray.push(meter.macAddress);
    this.electricity_array.push(row);

    let dt = this.residentialUnitForm.controls[
      'electricity_array'
    ] as FormArray;
    // dt.at(index).get('Umd_sR_no')?.disable();
    // dt.at(index).get('type')?.disable();

    console.log('eletcricity->', this.electricity_array.value);
    this.lengthOfelectricity = `Electricity ( ${this.electricity_array.length})`;
    if (this.electricity_array.length > 0) {
      this.isEleOpen = true;
    }
  }

  add_triSource_Row(meter: any, index: number): void {
    console.log(meter);
    let row = this.formBuilder.group({
      Umd_sR_no: [
        { value: meter.deviceSrno, disabled: true },
        Validators.required,
      ],
      type: [{ value: 'TriSource', disabled: true }, Validators.required],
      /*  Umd_sR_no: [meter.deviceSrno, Validators.required],
       type: ['TriSource', Validators.required], */
      installed_Location: [
        '',
        [
          Validators.required,
          Validators.pattern(this.regex_Alphanumeric),
          Validators.maxLength(25),
        ],
      ],
      meterInstallation_Date: [, [Validators.required]],
      initialReading: [
        '',
        [
          Validators.pattern(this.initialReadingExp),
          this.maxLimitValidator(99999),
        ],
      ],
      meter_InitialReadingDate: ['', [Validators.required]],
      Meter_Initial_Reading_EB_KWH: [
        '',
        [
          Validators.required,
          Validators.pattern(this.initialReadingExp),
          this.maxLimitValidator(99999),
        ],
      ],
      Meter_Initial_Reading_DG_KWH: [
        '',
        [
          Validators.required,
          Validators.pattern(this.initialReadingExp),
          this.maxLimitValidator(99999),
        ],
      ],

      Meter_Initial_Reading_Solar_KWH: [
        '',
        [
          Validators.required,
          Validators.pattern(this.initialReadingExp),
          this.maxLimitValidator(99999),
        ],
      ],

      umdNo: [meter.id],
    });
    this.macAddressTriSourceArray.push(meter.macAddress);
    this.triSource_array.push(row);

    let dt = this.residentialUnitForm.controls['triSource_array'] as FormArray;
    // dt.at(index).get('Umd_sR_no')?.disable();
    // dt.at(index).get('type')?.disable();

    console.log('TriSource->', this.electricity_array.value);
    this.lengthOfelTriSource = `TriSource ( ${this.triSource_array.length})`;
    if (this.triSource_array.length > 0) {
      this.isTriOpen = true;
    }
  }

  get electricity_array(): FormArray {
    return this.residentialUnitForm.get('electricity_array') as FormArray;
    //return (this.residentialUnitForm.get('electricity_array') as FormArray);
  }

  get triSource_array(): FormArray {
    return this.residentialUnitForm.get('triSource_array') as FormArray;
    //return (this.residentialUnitForm.get('electricity_array') as FormArray);
  }

  add_water_Row(meter: any, index: number): void {
    console.log(meter);
    let row = this.formBuilder.group({
      Umd_sR_no: [
        { value: meter.deviceSrno, disabled: true },
        Validators.required,
      ],
      type: [{ value: 'Water', disabled: true }, Validators.required],
      /* Umd_sR_no: [meter.deviceSrno, Validators.required],
      type: ['Water', Validators.required], */
      installed_Location: [
        '',
        [
          Validators.required,
          Validators.pattern(this.regex_Alphanumeric),
          Validators.maxLength(25),
        ],
      ],
      meterInstallation_Date: [, [Validators.required]],
      initialReading: [
        '',
        [
          Validators.required,
          Validators.pattern(this.initialReadingExp),
          this.maxLimitValidator(99999999),
        ],
      ],
      meter_InitialReadingDate: ['', [Validators.required]],
      umdNo: [meter.id],
    });
    this.macAddressWaterArray.push(meter.macAddress);
    this.water_array.push(row);

    let dt = this.residentialUnitForm.controls['water_array'] as FormArray;
    // let Umd_sR_no = dt.at(index).get('Umd_sR_no')?.disable();
    // let type = dt.at(index).get('type')?.disable();
    //console.log(Umd_sR_no)

    this.lengthOFwater =
      this.water_array.length > 0
        ? `Water ( ${this.water_array.length})`
        : 'Water';
    if (this.water_array.length > 0) {
      this.isWaterOpen = true;
    }
  }
  get water_array(): FormArray {
    return this.residentialUnitForm.get('water_array') as FormArray;
  }
  selectedDate: any;
  filterProjectBillDates: any;
  formatDateRange(dateRange: (Date | null)[]): string {
    if (dateRange && dateRange.length === 2 && dateRange[0] && dateRange[1]) {
      const startDate = formatDate(dateRange[0], 'dd/MM/YYYY', 'en-US');
      const endDate = formatDate(dateRange[1], 'dd/MM/YYYY', 'en-US');
      return `${startDate} to ${endDate}`;
    }
    return ''; // Return empty string if the date range is not valid
  }

  formatSingleDate(date: Date): string {
    if (!date) return '';

    return new Intl.DateTimeFormat('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    }).format(date);
  }

  todayDate: any;
  ngOnInit(): void {
    this.searchUtilityMeters();
    this.loaderService.setLoading(true);
    const currentDate = new Date();
    this.todayDate = currentDate.toISOString().split('T')[0];
    console.log(this.todayDate);
    this.ocupantForm.get('move_In_Date')?.valueChanges.subscribe((value) => {
      console.log('Selected Date:', value);
    });
    this.isCreate == 'edit';
    // console.log(this.formatDate(this.billGenerationDate))
    // console.log(this.billGenerationDate);

    this.residentialUnitForm.controls['Occupant_Name'].disable();
    this.residentialUnitForm.controls['date_registered'].disable();
    this.residentialUnitForm.controls['currentOccupiedPerson'].disable();

    this.residentialUnitForm.get('flat_house')?.valueChanges.subscribe(() => {
      this.refreshMetersRequiredValidators();
    });
  }

  Selectdates(event: any) {
    //this.selectedDate = event;
    console.log(event);
  }
  preventManualInput(event: KeyboardEvent): void {
    // Prevent all keys except Tab and Arrow keys, which are essential for navigating
    const allowedKeys = [
      'Tab',
      'ArrowLeft',
      'ArrowRight',
      'ArrowUp',
      'ArrowDown',
    ];
    if (!allowedKeys.includes(event.key)) {
      event.preventDefault(); // Prevent input
    }
  }
  onSortChange(sort: SortDescriptor[]): void {
    this.umdState.sort = sort;
    console.log(this.umdState.sort);
    const orderByQuery = this.sharedService.createOrderByQuery(
      this.umdState.sort,
    );

    this.meter_HistoryByQuery = orderByQuery;
    this.getResidentialHistorylist();
    /* this.store.dispatch(
      getResidentialHistorylist({
        pageIndex: this.UmdcurrentPage,
        pageSize: this.pageSize,
        searchTerm: this.searchedUmd,
        id: this.projectId,
        filter: this.umdqueryString,
        orderBy: this.umdorderByQuery,
        residentialunitid: this.updated_residenatilUnit.id,
      })
    ); */
  }

  onresidentialSortChange(sort: SortDescriptor[]): void {
    this.occupationState.sort = sort;
    console.log(this.occupationState.sort);
    const orderByQuery = this.sharedService.createOrderByQuery(
      this.occupationState.sort,
    );

    this.umdorderByQuery = orderByQuery;
    this.getOccupationHistorylist();
    /*  this.store.dispatch(
      getOccupationHistorylist({
        pageIndex: 1,
        pageSize: this.pageSize,
        searchTerm: '',
        id: this.updated_residenatilUnit.id,
        filter: this.queryString,
        orderBy: this.orderByQuery,
      })
    ); */
  }

  public meterValueChange(ev: string): void {
    const trimmedValue = ev.trim();

    // If user enters only spaces — do nothing (just keep the clear icon visible)
    if (trimmedValue.length === 0 && ev.length > 0) {
      return;
    }

    // If user cleared the box (either manually or by clicking the clear icon)
    if (ev.length === 0) {
      this.umdStateChange({ skip: 0, take: this.pageSize });
      //  this.getUsersData();
    }
    /*  if (ev.length == 0) {
      this.getResidentialHistorylist();
      
    } */
  }
  private triggerSearchUMD(): void {
    const trimmedValue = this.searchedUmd.trim();

    // If only spaces — do nothing
    if (trimmedValue.length === 0 && this.searchedUmd.length > 0) {
      return;
    }

    // If empty — load previous data
    if (this.searchedUmd.length === 0) {
      this.umdStateChange({ skip: 0, take: this.pageSize });
      this.getResidentialHistorylist();
      return;
    }

    // Otherwise — run search
    this.getResidentialHistorylist();
  }
  public occupaintValueChange(ev: string): void {
    const trimmedValue = ev.trim();

    // If user enters only spaces — do nothing (just keep the clear icon visible)
    if (trimmedValue.length === 0 && ev.length > 0) {
      return;
    }

    // If user cleared the box (either manually or by clicking the clear icon)
    if (ev.length === 0) {
      this.OccupationHistory({ skip: 0, take: this.pageSize });
      //  this.getUsersData();
    }
    /* console.log(this.searchedOccupant);
    if (ev.length == 0) {
      this.getOccupationHistorylist();
      
    } */
  }
  private triggerSearch(): void {
    const trimmedValue = this.searchedOccupant.trim();

    // If only spaces — do nothing
    if (trimmedValue.length === 0 && this.searchedOccupant.length > 0) {
      return;
    }

    // If empty — load previous data
    if (this.searchedOccupant.length === 0) {
      this.OccupationHistory({ skip: 0, take: this.pageSize });
      this.getOccupationHistorylist();
      return;
    }

    // Otherwise — run search
    this.getOccupationHistorylist();
  }
  onSearchResidentialUnits(): void {
    this.triggerSearch();
  }

  /*  isDisplay(key: string): boolean {
    const matchingUtility = this.configData?.utilities.find(
      (u: any) => u.name === key
    );
    
    return matchingUtility;
  } */

  isDisplay(key: string): boolean {
    const matchingUtility = this.configData?.utilities.find(
      (u: any) => u.name.toLowerCase() === key.toLowerCase(),
    );
    //console.log('Matching Utility:', matchingUtility);
    // Add or remove validators dynamically
    const controlNameMap: { [key: string]: string } = {
      gas: 'noOfGasMetersRequired',
      water: 'noOfWaterMetersRequired',
      electricity: 'noOfElectricityMetersRequired',
      trisource: 'noOfTriSourceMetersRequired',
    };

    const controlName = controlNameMap[key.toLowerCase()];
    const control = this.residentialUnitForm.get(controlName);
    const maxMetersRequired = this.getMetersRequiredMaxLimit();
    // console.log('Control Name:', controlName);
    // console.log('Control:', control);

    if (control) {
      if (matchingUtility) {
        control.setValidators([
          Validators.required,
          Validators.max(maxMetersRequired),
          Helper.positiveIntegerValidator(),
        ]);
      } else {
        control.clearValidators();
      }
      control.updateValueAndValidity({ emitEvent: false });
    }

    return !!matchingUtility; // ensures boolean return
  }

  private refreshMetersRequiredValidators(): void {
    ['Gas', 'Water', 'Electricity', 'trisource'].forEach((key) =>
      this.isDisplay(key),
    );
  }

  private getMetersRequiredMaxLimit(): number {
    const flatHouseValue = (
      this.residentialUnitForm.get('flat_house')?.value ?? ''
    )
      .toString()
      .trim()
      .toLowerCase();

    return flatHouseValue === 'unmapped' ? 10000 : 50;
  }

  getMetersRequiredMaxMessage(): string {
    return this.getMetersRequiredMaxLimit() === 10000
      ? 'Meter value cannot be greater than 10000.'
      : this.prifileValidations.residentialUnit.meterMaxValue;
  }

  getAllConfigData(): void {
    let payload = ['consumers', 'consumersWithNoRU', 'utilities'];
    this.sharedService.getAllConfigData(payload).subscribe({
      next: (data) => {
        if (
          data.statusCode === 200 &&
          data.message === 'Config data retrieved successfully.'
        ) {
          this.configData = data.data;
          const emailById = new Map(
            (this.configData?.consumers || []).map((item: any) => [
              item.id,
              item.email ?? '',
            ]),
          );

          const dropdownData = (this.configData?.consumers || []).map(
            (item: any) => ({
              id: item.id,
              name: `${item.firstName} ${item.lastName}`,
              email: emailById.get(item.id) ?? item.email ?? '',
            }),
          );
          this.ocupanyList = dropdownData;
          // Process consumers safely
          const ownerDropdownData = (this.configData?.consumers || []).map(
            (item: any) => ({
              id: item.id,
              name: `${item.firstName} ${item.lastName}`,
              email: item.email ?? '',
            }),
          );
          this.loaderService.setLoading(false);
          this.ownerList = ownerDropdownData;
          if (this.updated_residenatilUnit.id) {
            this.tabChange({ selectedIndex: 0 });
          }

          // Call if there's updated data
          /*  if (Object.keys(this.updated_residenatilUnit).length > 0) {
            this.getOcccupationHistoryStoreInfo();
          } */
        } else {
          console.warn('Unexpected response format or status:', data);
        }
      },

      error: (error: any) => {
        this.loaderService.setLoading(false);
        console.error('Error fetching config data:', error);
      },

      complete: () => {
        this.loaderService.setLoading(false);
        // Optional: stop loading indicator or log completion
        console.log('Config data load complete.');
      },
    });

    /*  this.residentialunitService.getProjectUmds(this.projectId).subscribe({
       next: (res) => {
         if (res.statusCode == 200) {
           if (this.updated_residenatilUnit.id == undefined) {
             this.loaderService.setLoading(false);
           }
           this.utilityTypeList = res.data.utilities;
           this.electricityList = res.data.utilityMeters.electricity;
           this.WaterList = res.data.utilityMeters.water;
           this.gasList = res.data.utilityMeters.gas;
           this.triSourceList = res.data.utilityMeters.triSource;
 
           this.filteredUtilityMeters ==
             this.electricityList?.concat(this.WaterList, this.gasList);
         }
         if (this.updated_residenatilUnit.id == undefined) {
           this.loaderService.setLoading(false);
         }
         console.log(res);
         console.log(this.triSourceList);
       },
       error: (err) => {
         this.loaderService.setLoading(false);
         console.log(err);
       },
     });  */
    /* if (Object.keys(this.updated_residenatilUnit).length > 0) {
      this.getOcccupationHistoryStoreInfo();
    } */
  }
  getLatesSearchUmds(searchText: string) {
    console.log('getLatesSearchUmds called with utilityMeters:', searchText);
    console.log('Selected Utility Type ID:', this.selectedUtilityType?.id);
    return this.residentialunitService.getLatesProjectUmdssUrl(
      this.selectedUtilityType.id,
      searchText,
    );
  }

  searchUtilityMeters(): void {
    this.utilitySearch$
      .pipe(
        debounceTime(400), // wait 400ms
        // distinctUntilChanged(),            // ignore same values
        filter((term) => term.length >= 6), //  only if 6+ characters
        switchMap((term) => {
          if (!term || term.trim().length < 6) {
            return of(null);
          }

          if (!this.selectedUtilityType?.id) {
            console.log('Utility Type ID missing');
            return of(null);
          }

          this.isLoading = true;
          return this.getLatesSearchUmds(term);
        }),
      )
      .subscribe({
        next: (res: any) => {
          if (res.statusCode == 200) {
            this.uitilityMetersList = res.data.utilityMeters;

            /* this.utilityTypeList = res.data.utilities;
            this.electricityList = res.data.utilityMeters.electricity;
            this.WaterList = res.data.utilityMeters.water;
            this.gasList = res.data.utilityMeters.gas;
            this.triSourceList = res.data.utilityMeters.triSource;
            this.filteredUtilityMeters ==
              this.electricityList?.concat(this.WaterList, this.gasList);

            let list = this.projectByUserList.filter((x: any) => x.id == this.selectedUtilityType.id); */
          }
          this.isLoading = false;
          if (this.updated_residenatilUnit.id == undefined) {
            this.loaderService.setLoading(false);
          }
          console.log(res);
          console.log(this.triSourceList);
        },
        error: () => {
          this.isLoading = false;
        },
      });
  }

  valueChnage_Owner(value: any) {
    this.selectedOwner = value;
    console.log(this.selectedOwner);
    console.log(this.residentialUnitForm.value);
    console.log(this.residentialUnitForm.controls['Occupant_Name'].value);

    // console.log(filetrdata)

    if (
      this.selectedOwner !== undefined &&
      this.selectedOwner.name ==
        this.residentialUnitForm.controls['Occupant_Name'].value
    ) {
      this.residentialUnitForm.controls['currentOccupiedPerson'].setValue(
        'Owner',
      );
    } else {
      if (this.residentialUnitForm.controls['Occupant_Name'].value == null) {
        this.residentialUnitForm.controls['currentOccupiedPerson'].setValue('');
      } else {
        this.residentialUnitForm.controls['currentOccupiedPerson'].setValue(
          'Tenant',
        );
      }
    }

    //console.log(this.residentialUnitForm.controls['currentOccupiedPerson'].value)
  }

  ocupantbuttonDisabled: boolean = true;
  valueChange_Occupant(value: any): void {
    console.log('valueChange', value);
    this.selectedOccupant = value;
    if (value != undefined && Object.keys(this.selectedOccupant).length > 0) {
      /* this.residentioalControls['owner_name'].setValidators( Validators.required);
      this.residentioalControls['owner_name'].updateValueAndValidity(); */
      //  this.occpantControls['move_In_Date'].setValidators(Validators.required);
      //  this.occpantControls['move_In_Date'].updateValueAndValidity();
      this.ocupantbuttonDisabled = false;
    } else {
      //  this.occpantControls['move_In_Date'].clearValidators();
      //  this.occpantControls['move_In_Date'].updateValueAndValidity();
      //this.ocupantbuttonDisabled = true
    }
  }

  dateChange(event: any): void {
    console.log(event);
    /* this.residentialUnitForm.patchValue({
      Registered_Date: event
    }); */
  }
  isvacantDate: boolean = false;
  vacantdateChange(event: any): void {
    console.log(event);
    // this.isvacantDate =this.ocupantForm.get('Vacant_Date')?.value !== '' ? true : false;
  }
  get residentioalControls() {
    return this.residentialUnitForm.controls;
  }
  OccupantsHistoryonFilter(value: any) {
    this.triggerSearch();
    // this.OccupationHistory({ skip: 0, take: this.pageSize });
  }
  public onFilter(value: any): void {
    this.umdPageChange({ skip: 0, take: this.umdhistorypageSize });
    this.getOccupationHistorylist();
    // const inputValue = value;
    /*  this.store.dispatch(
       getOccupationHistorylist({
         pageIndex: 1,
         pageSize: this.pageSize,
         searchTerm: this.searchedOccupant,
         id: this.updated_residenatilUnit.id,
         filter: this.queryString,
         orderBy: this.orderByQuery,
       })
     ); */
  }
  onSearchInvoicesAds(): void {
    this.triggerSearchUMD();
    /* if (this.invoicesearchedValue.length > 0) {
      this.getPaymentLinksList();
    } */
  }
  public umdonFilter(value: any): void {
    this.triggerSearchUMD();
    // const inputValue = value;
    // this.getResidentialHistorylist();
    //  this.umdPageChange({ skip: 0, take: this.umdhistorypageSize })
    /* this.store.dispatch(
      getResidentialHistorylist({
        pageIndex: this.UmdcurrentPage,
        pageSize: this.pageSize,
        searchTerm: this.searchedUmd,
        id: this.projectId,
        filter: this.umdqueryString,
        orderBy: this.umdorderByQuery,
        residentialunitid: this.updated_residenatilUnit.id,
      })
    ); */
  }

  public customFilterUMdState: State = {
    skip: 0,
    take: 10,
    filter: {
      logic: 'and',
      filters: [],
    },
  };

  async umdFilterChange(filter: CompositeFilterDescriptor) {
    this.skip = 0;

    this.customFilterUMdState = {
      skip: 0,
      take: 10,
      filter: {
        logic: 'and',
        filters: [],
      },
    };
    this.umdState.filter = filter;
    this.customFilterUMdState = _.cloneDeep(this.umdState);
    var filterOperators = await this.sharedService.togetFilterOperators(
      this.umdState,
    );
    console.log('temp-------------->', filterOperators);

    const iscustomdates = filterOperators?.filter((filter: any) => {
      return filter.value instanceof Date;
    });

    let isEq: any;
    let isNeq: any;
    this.customDateFiltersQueryEq = [];
    this.customDateFiltersQueryNEQ = [];
    if (iscustomdates && iscustomdates.length > 0) {
      isEq = iscustomdates.filter((filter: any) => filter.operator === 'eq');
      isNeq = iscustomdates.filter((filter: any) => filter.operator === 'neq');

      console.log('IsEq', isEq);
      console.log('isNeq', isNeq);

      if (isEq.length > 0) {
        this.customDateFiltersQueryEq =
          this.sharedService.customizeFilterQueryEQ(isEq);
        console.log('gasQueryString', this.customDateFiltersQueryEq);
      }
      if (isNeq?.length > 0) {
        isNeq.forEach((item: any) => {
          this.customDateFiltersQueryNEQ =
            this.sharedService.customizeFilterQueryNEQ(isNeq);
          console.log('gasQueryString', this.customDateFiltersQueryNEQ);
        });
      }
    } else {
      isNeq = undefined;
      isEq = undefined;
      this.customDateFiltersQueryEq = [];
      this.customDateFiltersQueryNEQ = [];
    }
    console.log('gasQueryString', this.customDateFiltersQueryEq);
    if (
      this.customDateFiltersQueryEq.length > 0 ||
      this.customDateFiltersQueryNEQ.length > 0
    ) {
      console.log(this.customFilterUMdState);
      let customFilterQueryString =
        await this.sharedService.newmodifyFilterJson(
          this.customFilterUMdState,
          this.customDateFiltersQueryEq,
          this.customDateFiltersQueryNEQ,
        );
      console.log(customFilterQueryString);
      this.umdqueryString = this.sharedService.dateFiltercreateQuery(
        customFilterQueryString,
      );
    } else {
      this.umdqueryString = this.sharedService.createQuery(
        this.customFilterUMdState,
      );
    }
    this.getResidentialHistorylist();

    /* this.store.dispatch(
      getResidentialHistorylist({
        pageIndex: this.UmdcurrentPage,
        pageSize: this.pageSize,
        searchTerm: this.searchedUmd,
        id: this.projectId,
        filter: this.umdqueryString,
        orderBy: this.umdorderByQuery,
        residentialunitid: this.updated_residenatilUnit.id,
      })
    ); */
    console.log(this.queryString);
  }

  public customFilterState: State = {
    skip: 0,
    take: 10,
    filter: {
      logic: 'and',
      filters: [],
    },
  };

  customDateFiltersQueryEq: any[] = [];
  customDateFiltersQueryNEQ: any[] = [];
  async onOccupaintFilterChange(filter: CompositeFilterDescriptor) {
    this.customFilterState = {
      skip: 0,
      take: 10,
      filter: {
        logic: 'and',
        filters: [],
      },
    };
    this.occupationState.filter = filter;
    this.customFilterState = _.cloneDeep(this.occupationState);
    var filterOperators = await this.sharedService.togetFilterOperators(
      this.occupationState,
    );
    console.log('temp-------------->', filterOperators);

    const iscustomdates = filterOperators?.filter((filter: any) => {
      return filter.value instanceof Date;
    });

    let isEq: any;
    let isNeq: any;
    this.customDateFiltersQueryEq = [];
    this.customDateFiltersQueryNEQ = [];
    if (iscustomdates && iscustomdates.length > 0) {
      isEq = iscustomdates.filter((filter: any) => filter.operator === 'eq');
      isNeq = iscustomdates.filter((filter: any) => filter.operator === 'neq');

      console.log('IsEq', isEq);
      console.log('isNeq', isNeq);

      if (isEq.length > 0) {
        this.customDateFiltersQueryEq =
          this.sharedService.customizeFilterQueryEQ(isEq);
        console.log('gasQueryString', this.customDateFiltersQueryEq);
      }
      if (isNeq?.length > 0) {
        isNeq.forEach((item: any) => {
          this.customDateFiltersQueryNEQ =
            this.sharedService.customizeFilterQueryNEQ(isNeq);
          console.log('gasQueryString', this.customDateFiltersQueryNEQ);
        });
      }
    } else {
      isNeq = undefined;
      isEq = undefined;
      this.customDateFiltersQueryEq = [];
      this.customDateFiltersQueryNEQ = [];
    }
    console.log('gasQueryString', this.customDateFiltersQueryEq);
    if (
      this.customDateFiltersQueryEq.length > 0 ||
      this.customDateFiltersQueryNEQ.length > 0
    ) {
      console.log(this.customFilterState);
      let customFilterQueryString =
        await this.sharedService.newmodifyFilterJson(
          this.customFilterState,
          this.customDateFiltersQueryEq,
          this.customDateFiltersQueryNEQ,
        );
      console.log(customFilterQueryString);
      this.queryString = this.sharedService.dateFiltercreateQuery(
        customFilterQueryString,
      );
    } else {
      this.queryString = this.sharedService.createQuery(this.customFilterState);
    }
    /*   this.occupationState.filter = filter; */
    console.log(this.occupationState);
    this.skip = 0;
    this.getOccupationHistorylist();
    // const queryString = this.sharedService.createQuery(this.occupationState);
    /*  this.store.dispatch(
      getOccupationHistorylist({
        pageIndex: 1,
        pageSize: this.pageSize,
        searchTerm: '',
        id: this.updated_residenatilUnit.id,
        filter: this.queryString,
        orderBy: this.orderByQuery,
      })
    ); */
    console.log(this.queryString);
  }
  isUtilityDisplay(type: string): boolean {
    const utility = this.currentUserData?.projectUtilities.find(
      (u: any) => u.name === type,
    );
    return !!utility; // Returns true if 'Electricity' is found, false otherwise
  }

  convertToUTC(date: string | Date): string {
    if (!date) return '';

    // Ensure it's always a Date object
    const parsedDate = new Date(date);

    if (isNaN(parsedDate.getTime())) {
      console.error('Invalid date:', date);
      return '';
    }

    const adjustedStartDate = new Date(
      parsedDate.getTime() - parsedDate.getTimezoneOffset() * 60000,
    );

    let selectedDate = adjustedStartDate.toISOString();
    console.log('UTC Converted:', selectedDate);
    return selectedDate;
  }

  saveResidentionalUnit(type: string) {
    this.submitted = true;
    let givenDate = new Date(
      this.residentialUnitForm.get('date_registered')?.value,
    );
    let previousDate = new Date(givenDate);
    previousDate.setDate(givenDate.getDate() - 1);

    if (this.selectedDate != undefined) {
      const originalDateString = this.selectedDate;
      const originalDate = new Date(originalDateString);
      originalDate.setUTCHours(0, 0, 0, 0);
      const modifiedDateString = originalDate.toISOString();
      console.log(modifiedDateString);
    }

    if (this.residentialUnitForm.valid) {
      const matchedPerson = this.ownerList.find((item: any) => {
        const fullName = item.name;
        return (
          fullName === this.residentialUnitForm.controls['Occupant_Name'].value
        );
      });

      var request: any = {
        projectId: this.projectId,
        flatNo: this.residentialUnitForm.get('flat_house')?.value,
        tower: this.residentialUnitForm.get('tower')?.value,
        floor: this.residentialUnitForm.get('floor')?.value,
        block: this.residentialUnitForm.get('block')?.value,
        occupantId: matchedPerson?.id == undefined ? null : matchedPerson?.id,
        moveInDate:
          this.residentialUnitForm.get('date_registered')?.value != null
            ? this.residentialUnitForm.get('date_registered')?.value
            : null,

        ownerId:
          this.residentialUnitForm.get('owner_name')?.value == ''
            ? null
            : this.residentialUnitForm.get('owner_name')?.value,
        SqftValue: this.residentialUnitForm.get('Square_feet')?.value,
        Tag: this.residentialUnitForm.get('residenatilTypes')?.value,
        noOfGasMetersRequired: this.residentialUnitForm.get(
          'noOfGasMetersRequired',
        )?.value,
        noOfWaterMetersRequired: this.residentialUnitForm.get(
          'noOfWaterMetersRequired',
        )?.value,
        noOfElectricityMetersRequired: this.residentialUnitForm.get(
          'noOfElectricityMetersRequired',
        )?.value,
        noOfTriSourceMetersRequired: this.residentialUnitForm.get(
          'noOfTriSourceMetersRequired',
        )?.value,
        //  currentOccupiedPerson: this.selectedOwner?.id ? 'Owner' : this.residentialUnitForm.get('currentOccupiedPerson')?.value,

        currentOccupiedPerson:
          this.residentialUnitForm.controls['Occupant_Name'].value != ''
            ? this.residentialUnitForm.get('currentOccupiedPerson')?.value
            : '',
      };
      let electricity: any[] = [];
      let gas: any[] = [];
      let water: any[] = [];
      let triSource: any[] = [];
      if (this.electricity_array.length > 0) {
        this.electricity_array.value.forEach((item: any) => {
          electricity.push({
            umdsrno: item.umdNo,
            type: 'electricity',
            installedLocation: item.installed_Location,
            meterInstallationDate: this.convertToUTC(
              item.meterInstallation_Date,
            ),
            meterInitialReadingEBKWH: item.Meter_Initial_Reading_EB_KWH,
            meterInitialReadingDGKWH: item.Meter_Initial_Reading_DG_KWH,
            // initialReading: 0,
            initialReadingDate: this.convertToUTC(
              item.meter_InitialReadingDate,
            ),
          });
        });
      }
      if (this.triSource_array.length > 0) {
        console.log(this.triSource_array.value);
        this.triSource_array.value.forEach((item: any) => {
          triSource.push({
            umdsrno: item.umdNo,
            type: 'TriSource',
            installedLocation: item.installed_Location,
            meterInstallationDate: this.convertToUTC(
              item.meterInstallation_Date,
            ),
            meterInitialReadingEBKWH: item.Meter_Initial_Reading_EB_KWH,
            meterInitialReadingDGKWH: item.Meter_Initial_Reading_DG_KWH,
            initialReadingDate: this.convertToUTC(
              item.meter_InitialReadingDate,
            ),
            meterInitialReadingSolarKWH: parseInt(
              item.Meter_Initial_Reading_Solar_KWH,
              10,
            ),
          });
        });
      }
      if (this.gas_array.length > 0) {
        this.gas_array.value.forEach((item: any) => {
          gas.push({
            umdsrno: item.umdNo,
            type: 'gas',
            installedLocation: item.installed_Location,
            meterInstallationDate: this.convertToUTC(
              item.meterInstallation_Date,
            ),
            initialReading: item.initialReading,
            initialReadingDate: this.convertToUTC(
              item.meter_InitialReadingDate,
            ),
          });
        });
      }
      if (this.water_array.length > 0) {
        this.water_array.value.forEach((item: any) => {
          water.push({
            umdsrno: item.umdNo,
            type: 'Water',
            installedLocation: item.installed_Location,
            meterInstallationDate: this.convertToUTC(
              item.meterInstallation_Date,
            ),
            initialReading: item.initialReading,
            initialReadingDate: this.convertToUTC(
              item.meter_InitialReadingDate,
            ),
          });
        });
      }
      ((request.gas = gas),
        (request.water = water),
        (request.electricity = electricity),
        (request.triSource = triSource),
        console.log(request));
      /*  if (this.selectedOccupant && this.selectedOccupant.id !== this.updated_residenatilUnit.occupantId) { */
      /*  if (
        Object.keys(this.updated_residenatilUnit).length > 0 &&
        this.updated_residenatilUnit?.id
      ) {
        if (this.selectedOccupant && this.isVacateDate) {
          request.vacateDate = vacateDate;
        }
      } */
      // console.log(this.residentialUnitForm.controls['currentOccupiedPerson'].value)
      if (type === 'Create') {
        this.store.dispatch(
          createResidentialUnit({ ResidentialUnit: request }),
        );
      } else {
        this.store.dispatch(
          updateResidentialUnit({
            ResidentialUnit: request,
            id: this.residenatilUnitByidData.id,
          }),
        );
      }
    }
  }

  formatDate(isoString: any) {
    const date = new Date(isoString);
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  }
  isVacateDate: boolean = false;
  saveOcupant() {
    //console.log(this.residentialUnitForm.get('owner_name')?.value)
    // if (this.residentialUnitForm.get('owner_name')?.value !== null) {
    this.occupantSubmitted = true;
    console.log(this.ocupantForm.value);
    // console.log(this.selectedDate)

    /*  console.log(this.formatDate(
       this.ocupantForm.get('move_In_Date')?.value
     )) */

    if (this.ocupantForm.valid) {
      this.isVacateDate = true;
      this.residentialUnitForm.patchValue({
        date_registered: this.ocupantForm.get('move_In_Date')?.value,
        // Occupant_Name: this.ocupantForm.get('ocupantName')?.value.name,
        Occupant_Name: this.selectedOccupant?.name,
      });

      console.log(this.residentialUnitForm.controls['Occupant_Name'].value);

      //console.log(this.selectedOwner.name);

      if (this.residentialUnitForm.get('owner_name')?.value !== null) {
        if (
          this.selectedOwner !== undefined &&
          this.selectedOwner.name ==
            this.residentialUnitForm.controls['Occupant_Name'].value
        ) {
          this.residentialUnitForm.controls['currentOccupiedPerson'].setValue(
            'Owner',
          );
        } else {
          this.residentialUnitForm.controls['currentOccupiedPerson'].setValue(
            'Tenant',
          );
        }
      } else {
        this.residentialUnitForm.controls['currentOccupiedPerson'].setValue(
          'Tenant',
        );
      }
      this.isOcupantEnable = true; // to show Occuant from feilds
      this.modalService.hide();
      this.modalRef.hide();
      console.log(this.residentialUnitForm);
    }
    /*  } else {
 
       this.sharedService.showMessageDialog(
         'Please Select Owner',
         '',
         SweetAlertIcon.ERROR
       );
 
     } */
  }

  save() {
    this.modalRef.hide();
  }
  eleError: boolean = false;
  umdSubmit: boolean = false;
  saveUmdTemp() {
    this.umdSubmit = true;
    console.log(this.umdForm);

    if (this.umdForm.valid) {
      switch (this.selectedUtilityType) {
        case 'Electricity':
          this.selectedUtilitymeter.forEach((x: any, index: number) => {
            if (!this.macAddressEleArray?.includes(x.macAddress)) {
              x.deviceSrno =
                x.meterSerialNo != undefined ? x.meterSerialNo : '';
              this.add_electricity_Row(x, index);
              this.eleError = false;
            } else {
              this.eleError = true;
            }
          });
          break;
        case 'Gas':
          this.selectedUtilitymeter.forEach((x: any, index: number) => {
            if (!this.macAddressGasArray?.includes(x.macAddress)) {
              x.deviceSrno =
                x.meterSerialNo != undefined ? x.meterSerialNo : '';
              this.add_gas_Row(x, index);
              this.eleError = false;
            } else {
              this.eleError = true;
            }
          });

          break;
        case 'Water':
          this.selectedUtilitymeter.forEach((x: any, index: number) => {
            if (!this.macAddressWaterArray?.includes(x.macAddress)) {
              x.deviceSrno =
                x.meterSerialNo != undefined ? x.meterSerialNo : '';
              this.add_water_Row(x, index);
              this.eleError = false;
            } else {
              this.eleError = true;
            }
          });
          break;
      }
      this.modelRef_1.hide();
    }
  }

  saveUmd() {
    this.umdSubmit = true;
    console.log(this.umdForm);
    console.log(this.selectedUtilityType);
    // Check if the form is valid before proceeding
    if (this.umdForm.valid) {
      // Handle the utility meter rows dynamically
      this.handleUtilityMeterRows(this.selectedUtilityType.name);
      this.modelRef_1.hide();
    } else {
      console.error('Form is not valid');
    }
  }

  handleUtilityMeterRows(utilityType: UtilityType) {
    // Map to dynamically handle different utilities
    const utilityDataMap: Record<
      UtilityType,
      {
        macAddressArray: string[];
        addRowFunction: (x: any, index: number) => void;
      }
    > = {
      Electricity: {
        macAddressArray: this.macAddressEleArray,
        addRowFunction: this.add_electricity_Row.bind(this),
      },
      Gas: {
        macAddressArray: this.macAddressGasArray,
        addRowFunction: this.add_gas_Row.bind(this),
      },
      Water: {
        macAddressArray: this.macAddressWaterArray,
        addRowFunction: this.add_water_Row.bind(this),
      },
      EV: {
        macAddressArray: this.macAddressEVArray,

        addRowFunction: function (x: any, index: number): void {
          throw new Error('Function not implemented.');
        },
      },
      TriSource: {
        macAddressArray: this.macAddressTriSourceArray,
        addRowFunction: this.add_triSource_Row.bind(this),
        /*  addRowFunction: function (x: any, index: number): void {
           throw new Error('Function not implemented.');
         } */
      },
    };

    // Find the appropriate data based on the utility type
    const utilityData = utilityDataMap[utilityType];

    // If no utility data is found for the given utility type, exit early
    if (!utilityData) {
      console.error(`Utility type "${utilityType}" not found in map.`);
      return;
    }

    // Iterate through selected utility meters and handle each one
    this.selectedUtilitymeter.forEach((x: any, index: number) => {
      // Check if the current meter's macAddress is already in the list
      const isMacAddressExists = utilityData.macAddressArray?.includes(
        x.macAddress,
      );

      // If the macAddress is not already included, process the meter data
      if (!isMacAddressExists) {
        x.deviceSrno = x.meterSerialNo != undefined ? x.meterSerialNo : '';
        utilityData.addRowFunction(x, index); // Call the appropriate function based on utility type
        this.eleError = false;
      } else {
        // If macAddress exists in the list, set error flag
        this.eleError = true;
        this.sharedService.showMessageDialog(
          `Duplicate macAddress found for meter at index ${x.meterSerialNo}: ${x.macAddress}`,
          '',
          SweetAlertIcon.ERROR,
        );
        console.warn(
          `Duplicate macAddress found for meter at index ${index}: ${x.macAddress}`,
        );
      }
    });

    // Optionally, you can handle additional logic here if needed (e.g., show an error message for duplicate macAddress)
  }

  openOccupant(template: any) {
    //console.log(this.ownerList);

    this.loaderService.setLoading(false);

    this.isvacantDate = false;
    this.occupantSubmitted = false;
    //console.log(this.ownerList);

    // console.log(this.ocupantForm.controls['move_In_Date'].value);
    this.ocupantForm.controls['move_In_Date'].setValue('');
    //this.ocupantForm.controls['Vacant_Date'].setValue('');
    this.ocupantForm.controls['ocupantName'].setValue([]);
    this.filterOccupant();
    if (this.residentialUnitForm.controls['Occupant_Name'].value != '') {
      this.filterOccupant();
    }
    //Occupant_Name

    this.modalRef = this.modalService.show(template, {
      class: 'modal-lg modal-dialog-centered',
      backdrop: 'static',
    });
  }

  removedOccupant(template: any) {
    this.removeModalRef = this.modalService.show(template, {
      class: 'modal-dialog-centered',
    });
  }
  onMacClear() {
    this.uitilityMetersList = [];

    // Important: push empty value to reset stream
    this.utilitySearch$.next('');

    // optional safety
    this.isLoading = false;
  }
  utilityChange(event: any) {
    if (event == undefined || event == null) {
      this.uitilityMetersList = [];
      this.selectedvlaue = [];
      this.selectedUtilityType = {};
      this.selectedUtilitymeter = [];
      this.umdForm.get('utitlityMeters')?.reset();
      // 🔥 reset typeahead stream
      this.utilitySearch$ = new Subject<string>();
      this.searchUtilityMeters(); // reattach stream
      return;
    }
    this.umdForm.get('utitlityMeters')?.reset();
    this.selectedUtilitymeter = [];
    this.uitilityMetersList = [];
    this.utilitySearch$ = new Subject<string>();
    this.searchUtilityMeters(); // reattach stream

    console.log(event);
    this.selectedUtilityType = event;
    this.selectedvlaue = [];
    /*  switch (event?.name) {
      case 'Electricity':
        if (this.macAddressEleArray.length > 0) {
          this.uitilityMetersList = this.electricityList.filter(
            (x: any) => !this.macAddressEleArray?.includes(x.macAddress)
          );
        } else {
          this.uitilityMetersList = this.electricityList;
        }
        break;
     
      case 'TriSource':
        if (this.macAddressTriSourceArray.length > 0) {
          this.uitilityMetersList = this.triSourceList.filter(
            (x: any) => !this.macAddressEleArray?.includes(x.macAddress)
          );
        } else {
          this.uitilityMetersList = this.triSourceList;
        }
        console.log(this.triSourceList);
        console.log(this.uitilityMetersList);
        break;

      case 'Water':
        if (this.macAddressWaterArray.length > 0) {
          this.uitilityMetersList = this.WaterList.filter(
            (x: any) => !this.macAddressWaterArray?.includes(x.macAddress)
          );
        } else {
          this.uitilityMetersList = this.WaterList;
        }
       

        break;
      case 'Gas':
        if (this.macAddressGasArray.length > 0) {
          this.uitilityMetersList = this.gasList.filter(
            (x: any) => !this.macAddressGasArray?.includes(x.macAddress)
          );
        } else {
          this.uitilityMetersList = this.gasList;
        }
       

        break;
    } */
  }
  @ViewChild(TooltipDirective) public tooltipDir: TooltipDirective | undefined;
  public showTooltip(e: MouseEvent): void {
    const element = e.target as HTMLElement;
    // Check if the element is a table cell
    if (element.nodeName === 'TD') {
      const cellValue = element.innerText.trim();
      // Only show the tooltip if the cell is not empty, null, or ''
      if (cellValue && !element.closest('.no-tooltip')) {
        this.tooltipDir?.toggle(element);
      } else {
        this.tooltipDir?.hide();
      }
    } else if (element.classList.contains('k-column-title')) {
      this.tooltipDir?.toggle(element);
    } else {
      this.tooltipDir?.hide();
    }
  }

  public umdshowTooltip(e: MouseEvent): void {
    const element = e.target as HTMLElement;
    // Check if the element is a table cell
    if (element.nodeName === 'TD') {
      const cellValue = element.innerText.trim();
      // Only show the tooltip if the cell is not empty, null, or ''
      if (cellValue && !element.closest('.no-tooltip')) {
        this.tooltipDir?.toggle(element);
      } else {
        this.tooltipDir?.hide();
      }
    } else if (element.classList.contains('k-column-title')) {
      this.tooltipDir?.toggle(element);
    } else {
      this.tooltipDir?.hide();
    }
  }

  utilityMeterChange(event: any) {
    if (event == undefined || event == null) {
      this.selectedUtilitymeter = [];
      this.umdForm.get('utitlityMeters')?.reset();
      return;
    }
    console.log(event);
    this.selectedUtilitymeter = [];
    this.selectedUtilitymeter = event;
  }
  /* tagMapper(tags: any[]): any[] {
    return tags.length < 2 ? tags : [tags];
  } */

  openUmd(addUmd: any) {
    this.umdForm.reset();
    this.umdSubmit = false;
    this.uitilityMetersList = [];
    this.selectedUtilityType = null;
    this.selectedvlaue = [];
    this.modelRef_1 = this.modalService.show(addUmd, {
      class: 'modal-dialog-centered',
      backdrop: 'static', //
    });
  }

  getResidentialUnitByid() {
    this.residentialunitService
      .getResidentialUnitById(this.updated_residenatilUnit.id)
      .subscribe({
        next: (res) => {
          console.log(res);
          if (res.statusCode == 200) {
            this.residentialUnitForm.reset();
            console.log('res-----', res);
            this.residenatilUnitByidData = {};
            this.residenatilUnitByidData = { ...res.data };
            this.selectedDate = res.data?.moveInDate;
            if (Object.keys(this.residenatilUnitByidData).length > 0) {
              this.isCreate = 'edit';
              console.log('res-----', res);
              //this.isOcupantEnable = true;
              this.isOcupantEnable =
                this.residenatilUnitByidData.occupant == '' ? false : true;
              this.ocupantbuttonDisabled = false;

              console.log(
                'this.billingType-----',
                this.residenatilUnitByidData.billingDate,
              );

              const today = new Date();
              this.minDate = today;

              this.residentialUnitForm.patchValue({
                flat_house: this.residenatilUnitByidData?.flatNo
                  ? this.residenatilUnitByidData.flatNo
                  : '',
                floor: this.residenatilUnitByidData?.floor
                  ? this.residenatilUnitByidData.floor
                  : '',
                tower: this.residenatilUnitByidData?.tower
                  ? this.residenatilUnitByidData.tower
                  : '',
                block: this.residenatilUnitByidData?.block
                  ? this.residenatilUnitByidData.block
                  : '',
                noOfTriSourceMetersRequired:
                  this.residenatilUnitByidData?.noOfTriSourceMetersRequired,
                noOfElectricityMetersRequired:
                  this.residenatilUnitByidData?.noOfElectricityMetersRequired,
                noOfWaterMetersRequired:
                  this.residenatilUnitByidData?.noOfWaterMetersRequired,
                noOfGasMetersRequired:
                  this.residenatilUnitByidData?.noOfGasMetersRequired,

                date_registered: this.residenatilUnitByidData?.moveInDate
                  ? new Date(this.residenatilUnitByidData.moveInDate)
                  : null,
                currentOccupiedPerson: this.residenatilUnitByidData
                  ?.currentOccupiedPerson
                  ? this.residenatilUnitByidData.currentOccupiedPerson
                  : '',
                Occupant_Name: this.residenatilUnitByidData?.occupant
                  ? this.residenatilUnitByidData.occupant
                  : '',
                owner_name: this.residenatilUnitByidData?.ownerId
                  ? this.residenatilUnitByidData.ownerId
                  : '',
                residenatilTypes: this.residenatilUnitByidData?.tag
                  ? this.residenatilUnitByidData.tag
                  : '',
                Square_feet: this.residenatilUnitByidData?.sqftValue
                  ? this.residenatilUnitByidData.sqftValue
                  : '',
              });
              this.ownerList?.forEach((item: any) => {
                if (item.id == this.residenatilUnitByidData.ownerId) {
                  this.selectedOwner = item;
                }
              });

              console.log(this.selectedOwner);
              let occupant = {
                id: this.residenatilUnitByidData.occupantId,
                name: this.residenatilUnitByidData.occupant,
              };
              this.selectedOccupant = occupant;
              this.residenatilUnitByidData?.gas.forEach(
                (item: any, index: number) => {
                  this.add_gas_Row(item, index);
                },
              );
              //console.log(this.gas_array.length);
              // console.log(this.residenatilUnitByidData.gas.length);
              this.residenatilUnitByidData?.water.forEach(
                (item: any, index: number) => {
                  this.add_water_Row(item, index);
                },
              );
              this.residenatilUnitByidData?.electricity.forEach(
                (item: any, index: number) => {
                  this.add_electricity_Row(item, index);
                },
              );
              this.residenatilUnitByidData?.triSource.forEach(
                (item: any, index: number) => {
                  this.add_triSource_Row(item, index);
                },
              );

              this.residenatilUnitByidData?.gas.forEach(
                (item: any, index: number) => {
                  console.log(item.meterInstallationDate);
                  console.log(this.formatDate(item.initialReadingDate));
                  //new Date('2025-03-04T08:54:43.000Z')

                  let dt = this.residentialUnitForm.controls[
                    'gas_array'
                  ] as FormArray;
                  dt.at(index).patchValue({
                    installed_Location: item.installedLocation,
                    meterInstallation_Date: new Date(
                      item.meterInstallationDate,
                    ),
                    initialReading: item.initialReading,
                    meter_InitialReadingDate: new Date(item.initialReadingDate),
                    umdNo: item.umdsrno,
                  });
                },
              );

              this.residenatilUnitByidData?.triSource.forEach(
                (item: any, index: number) => {
                  let dt = this.residentialUnitForm.controls[
                    'triSource_array'
                  ] as FormArray;
                  dt.at(index).patchValue({
                    installed_Location: item.installedLocation,
                    meterInstallation_Date: new Date(
                      item.meterInstallationDate,
                    ),
                    initialReading: item.initialReading,
                    meter_InitialReadingDate: new Date(item.initialReadingDate),
                    umdNo: item.umdsrno,
                    Meter_Initial_Reading_EB_KWH: item.meterInitialReadingEBKWH,
                    Meter_Initial_Reading_DG_KWH: item.meterInitialReadingDGKWH,
                    Meter_Initial_Reading_Solar_KWH:
                      item.meterInitialReadingSolarKWH,
                  });
                },
              );
              this.residenatilUnitByidData.electricity.forEach(
                (item: any, index: number) => {
                  let dt = this.residentialUnitForm.controls[
                    'electricity_array'
                  ] as FormArray;
                  dt.at(index).patchValue({
                    installed_Location: item.installedLocation,
                    meterInstallation_Date: new Date(
                      item.meterInstallationDate,
                    ),
                    initialReading: item.initialReading,
                    meter_InitialReadingDate: new Date(item.initialReadingDate),
                    umdNo: item.umdsrno,
                    Meter_Initial_Reading_EB_KWH: item.meterInitialReadingEBKWH,
                    Meter_Initial_Reading_DG_KWH: item.meterInitialReadingDGKWH,
                  });
                },
              );

              this.residenatilUnitByidData.water.forEach(
                (item: any, index: number) => {
                  let dt = this.residentialUnitForm.controls[
                    'water_array'
                  ] as FormArray;
                  dt.at(index).patchValue({
                    installed_Location: item.installedLocation,
                    meterInstallation_Date: new Date(
                      item.meterInstallationDate,
                    ),
                    initialReading: item.initialReading,
                    meter_InitialReadingDate: new Date(item.initialReadingDate),
                    umdNo: item.umdsrno,
                  });
                },
              );
              this.loaderService.setLoading(false);
            } else {
              this.loaderService.setLoading(false);
            }
          }
        },
        error: (err) => {
          console.log(err);
          this.loaderService.setLoading(false);

          // Check if backend returned an error.message
          const errorMsg =
            err.error?.message ||
            'Something went wrong. Please try again later.';

          this.sharedService.showMessageDialog(
            errorMsg,
            '',
            SweetAlertIcon.ERROR,
          );
        },
      });
  }

  getOccupationHistorylist() {
    this.loaderService.setLoading(true);
    this.residentialunitService
      .getOccupationHistoryUnit(
        this.currentPage,
        this.pageSize,
        this.searchedOccupant,
        this.updated_residenatilUnit.id,
        this.queryString,
        this.umdorderByQuery,
      )
      .subscribe({
        next: (res) => {
          console.log(res);
          if ((res.statusCode = 200)) {
            this.occupationHistoryList = [...res.data.items];
            this.pageSize = res.data.pageSize;
            this.totalUserCount = res.data.totalCount;
            this.loadGridTable();
          } else {
            this.loaderService.setLoading(false);
          }
        },
        error: (err) => {
          console.log(err);
          this.loaderService.setLoading(false);

          // Check if backend returned an error.message
          const errorMsg =
            err.error?.message ||
            'Something went wrong. Please try again later.';

          this.sharedService.showMessageDialog(
            errorMsg,
            '',
            SweetAlertIcon.ERROR,
          );
        },
      });
  }
  clearFormArray(formArray: FormArray) {
    while (formArray.length !== 0) {
      formArray.removeAt(0);
    }
  }
  getResidentialHistorylist() {
    this.loaderService.setLoading(true);
    this.residentialunitService
      .getresidentialunitumdhistory(
        this.UmdcurrentPage,
        this.umdhistorypageSize,
        this.searchedUmd,
        this.projectId,
        this.umdqueryString,
        this.meter_HistoryByQuery,
        this.updated_residenatilUnit.id,
      )
      .subscribe({
        next: (res) => {
          if ((res.statusCode = 200)) {
            this.residentialUniUmdHistoryList = [...res.data.items];
            this.umdhistorypageSize = res.data.pageSize;
            this.umdhistorytotalUserCount = res.data.totalCount;

            this.loadUmdHistrory();
            console.log(res);
          } else {
            this.loaderService.setLoading(false);
          }
        },
        error: (err) => {
          console.log(err);
          this.loaderService.setLoading(false);

          // Check if backend returned an error.message
          const errorMsg =
            err.error?.message ||
            'Something went wrong. Please try again later.';

          this.sharedService.showMessageDialog(
            errorMsg,
            '',
            SweetAlertIcon.ERROR,
          );
        },
      });
  }
  selectedIndex: number = 2;
  tabChange(event: any) {
    this.selectedIndex = event.selectedIndex;
    //console.log(event.selectedIndex);
    //  console.log('Previous step index:', event.previouslySelectedIndex);
    this.customDateFiltersQueryEq = [];
    this.customDateFiltersQueryNEQ = [];
    if (event.selectedIndex == 0) {
      // this.store.dispatch(resetResidentialUnitState()); // Optionally reset state

      // Before making API call
      [
        'gas_array',
        'water_array',
        'electricity_array',
        'triSource_array',
      ].forEach((key) => {
        this.clearFormArray(this.residentialUnitForm.get(key) as FormArray);
      });
      this.getResidentialUnitByid();
    }
    if (event.selectedIndex == 1) {
      this.getOccupationHistorylist();
    }
    if (event.selectedIndex == 2) {
      this.getResidentialHistorylist();
    }
  }
  exportAll() {
    this.residentialunitService
      .getOccupationHistoryUnit(
        1,
        this.totalUserCount,
        this.searchedOccupant,
        this.updated_residenatilUnit.id,
        this.queryString,
        this.orderByQuery,
      )
      .subscribe({
        next: (res) => {
          if ((res.statusCode = 200)) {
            this.exportdata = [];
            if (res.data.items.length > 0) {
              this.exportdata = [...res.data.items];
              const transformedData = this.exportdata.map((item: any) => ({
                'Occupant Name': item.name,
                'Move In Date':
                  item.moveInDate != null
                    ? this.sharedService.dateFormateChnagewithoutTime(
                        item.moveInDate,
                      )
                    : '',
                'Vacate Date':
                  item.vacateDate != null
                    ? this.sharedService.dateFormateChnagewithoutTime(
                        item.vacateDate,
                      )
                    : '',
              }));
              this.PdfexportService.downloadExcel(
                transformedData,
                'OccupoiantHistory',
              );
            } else {
              this.loaderService.setLoading(false);
              this.sharedService.showMessageDialog(
                'No data to display',
                '',
                SweetAlertIcon.ERROR,
              );
            }
          } else {
            this.loaderService.setLoading(false);
            this.sharedService.showMessageDialog(
              'No data to display',
              '',
              SweetAlertIcon.ERROR,
            );
          }
        },
        error: (err) => {
          console.log(err);
          this.loaderService.setLoading(false);

          // Check if backend returned an error.message
          const errorMsg =
            err.error?.message ||
            'Something went wrong. Please try again later.';

          this.sharedService.showMessageDialog(
            errorMsg,
            '',
            SweetAlertIcon.ERROR,
          );
        },
      });

    /* this.store.dispatch(
      getOccupationHistoryExpotyExcellist({
        pageIndex: 1,
        pageSize: ,
        searchTerm: '',
        id: this.updated_residenatilUnit.id,
        filter: this.queryString,
        orderBy: this.orderByQuery,
      })
    ); */
    //this.getAllResidentialUnitlist();
  }

  umdExportAll() {
    this.residentialunitService
      .getresidentialunitumdhistory(
        1,
        this.umdhistorytotalUserCount,
        '',
        this.projectId,
        '',
        '',
        this.updated_residenatilUnit.id,
      )
      .subscribe({
        next: (res) => {
          if ((res.statusCode = 200)) {
            this.umdexportdata = [];
            if (res.data.items.length > 0) {
              this.umdexportdata = [...res.data.items];
              const transformedData = this.umdexportdata.map((item: any) => ({
                'Device Sr No': item.umdsrno,
                'MAC Address': item.macAddress,
                Type: item.type,
                'Installed Location': item.installedLocation,
                'Initial Reading': item.initialReading,

                'Meter Installed Date':
                  this.sharedService.dateFormateChnagewithoutTime(
                    item.meterInstallationDate,
                  ),
                'Meter Initial reading DG KWH': item.initialReadingDGKWH,
                'Meter Initial Reading EB KWH': item.initialReadingEBKWH,
                'Initial Reading Date':
                  this.sharedService.dateFormateChnagewithoutTime(
                    item.initialReadingDate,
                  ),
                'updated date': this.sharedService.dateFormateChnage(
                  item?.modifiedOn,
                ),
                'Modified By': item.modifiedBy,
                Action: item.action,
              }));
              this.PdfexportService.downloadExcel(
                transformedData,
                'Meter History',
              );
            } else {
              this.sharedService.showMessageDialog(
                'No data to display',
                '',
                SweetAlertIcon.ERROR,
              );
            }
          } else {
            this.sharedService.showMessageDialog(
              'No data to display',
              '',
              SweetAlertIcon.ERROR,
            );
          }
        },
        error: (err) => {
          console.log(err);
          this.loaderService.setLoading(false);

          // Check if backend returned an error.message
          const errorMsg =
            err.error?.message ||
            'Something went wrong. Please try again later.';

          this.sharedService.showMessageDialog(
            errorMsg,
            '',
            SweetAlertIcon.ERROR,
          );
        },
      });
  }

  public onExport(type: string) {
    if (this.residentialunitgridData.data.length > 0) {
      if (type === 'Excel') {
        setTimeout(() => {
          this.hiddenGrid?.saveAsExcel();
        }, 1000);
      }
    } else {
      this.sharedService.showMessageDialog(
        'No data to display',
        '',
        SweetAlertIcon.ERROR,
      );
    }

    /* else if (type === 'Pdf') {
      setTimeout(() => {
        this.hiddenGrid?.saveAsPDF();
      }, 1000);
    } */
  }
  public umdonExport(type: string) {
    if (type === 'Excel') {
      if (this.residentialunitUmdHistorygridData.data.length > 0) {
        setTimeout(() => {
          this.umdGrid?.saveAsExcel();
        }, 1000);
      } else {
        this.sharedService.showMessageDialog(
          'No data to display',
          '',
          SweetAlertIcon.ERROR,
        );
      }
    }
  }

  editMeter(dataItem: any) {}

  deleteMeter(dataItem: any) {}

  openCalendar() {
    // this.datePickerInput.nativeElement.focus(); // Triggers the datepicker
    this.datePicker.show(); // ✅ thi
  }
  openCalendar2() {
    this.datePicker2.show(); // ✅ thi
  }
  openCalendargas1() {
    this.datepickergas1.show(); // ✅ thi
  }
  openCalendargas2() {
    this.datepickergas2.show(); // ✅ thi
  }

  openCalendarEle1() {
    this.datepickerEle1.show(); // ✅ thi
  }
  openCalendarEle2() {
    const dateInput = document.querySelector('.form-control.date');
    this.datepickerEle2.show(); // ✅ thi
  }
  clearDategas1(gasGroup: AbstractControl) {
    gasGroup.get('meterInstallation_Date')?.setValue(null);
  }
  clearDategas2(gasGroup: AbstractControl) {
    gasGroup.get('meter_InitialReadingDate')?.setValue(null);
  }
  preventTyping(event: KeyboardEvent) {
    event.preventDefault();
  }

  //datepickerEle1
  clearDateEle1(eleGroup: AbstractControl) {
    eleGroup.get('meterInstallation_Date')?.setValue(null);
  }
  clearDatEle2(eleGroup: AbstractControl) {
    eleGroup.get('meter_InitialReadingDate')?.setValue(null);
  }

  clearDate(waterGroup: AbstractControl) {
    waterGroup.get('meterInstallation_Date')?.setValue(null);
  }
  clearnitialReadingDate(waterGroup: AbstractControl) {
    waterGroup.get('meter_InitialReadingDate')?.setValue(null);
  }
  /*  clearDate(waterForm: FormGroup) {
     waterForm.get('meterInstallation_Date')?.setValue(null);
   }
*/
  clearDate_test() {
    this.selectedDate = null; // Clear the selected date
    // this.projectForm.controls['StartDate'].setValue(null);
  }
  openCalendar_test() {
    // Trigger the click event on the input field to open the datepicker
    const dateInput = document.querySelector('.form-control.date_test');
    dateInput?.dispatchEvent(new Event('click'));
  }
  maxLimitValidator(max: number) {
    return (control: AbstractControl) => {
      const value = parseFloat(control.value);
      return !isNaN(value) && value > max ? { maxLimit: true } : null;
    };
  }
}
